/* eslint-disable no-nested-ternary */
import { callIf } from "./fn";

const isOutsideOf = el => ({ target }) => !(el === target || el.contains(target));

const topBarEventOf = (el, event) => {
	return el.firstChild.contains(event.target)
		? 1 // toggle
		: el.contains(event.target) && event.target.closest(".topbar-toggle-action") == null
		? 2 // open
		: el.contains(event.target) && event.target.closest(".topbar-toggle-action") != null
		? 3 // close
		: 4; // close
};

export const onTopbarOutsideClick = (el, handler) => {
	const documentClickHandler = e => {
		const eventType = topBarEventOf(el, e);
		return handler(eventType);
	};
	document.addEventListener("click", documentClickHandler);
	return () => document.removeEventListener("click", documentClickHandler);
};

const onOutsideClick = (el, handler) => {
	const documentClickHandler = callIf(isOutsideOf(el), handler);
	document.addEventListener("click", documentClickHandler);
	return () => document.removeEventListener("click", documentClickHandler);
};

export default onOutsideClick;
